import classnames from 'classnames';

interface Props {
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

const ButtonFooter = (props: Props): JSX.Element => {
  const { children, className, id } = props;

  return (
    children && (
      <div
        id={id}
        className={classnames(
          'px-md py-sm border-t border-brand-border w-full bg-brand-background-primary browser-safe-area-bottom',
          className,
        )}
      >
        <div className="safe-area-bottom w-full">{children}</div>
      </div>
    )
  );
};

export default ButtonFooter;
